import React, { useCallback } from 'react';
import { flag } from 'app/modules/post/post.actions';
import { useRequireRole, MemberRole } from 'modules/community';
import { useSelector, useDispatch } from 'react-redux';
import { BodyText } from 'modules/styled';
import { Popup } from 'modules/ui/web/popup';
import { deleteComment } from 'modules/comment/comment.actions';
import { showModal } from 'modules/navigation/navigation.actions';

interface CommentPopupProps {
  comment: any;
  setEditing: (state: boolean) => void;
}

export const CommentPopup = ({ comment, setEditing }: CommentPopupProps): JSX.Element => {
  const dispatch = useDispatch();
  const userId = useSelector((state: any) => state?.auth?.user?._id);

  const isOwner = userId && userId === comment.user;
  const isAdmin = useRequireRole(MemberRole.ADMIN);

  const flagPost = () => dispatch(flag(comment));

  const deletePost = (commentId: string) => {
    // TODO custom confirm
    // eslint-disable-next-line
    const okToDelete = confirm('Are you sure you want to delete this post?');
    if (!okToDelete) return;
    dispatch(deleteComment(commentId));
  };

  const auditUser = (userId: string) => {
    dispatch(showModal('relatedUsers', { userId }));
  };

  const getOptions = useCallback(
    (isOwner: boolean, isAdmin: boolean) => {
      switch (true) {
        case isOwner:
          return [
            { text: 'Edit Post', action: () => setEditing(true) },
            { text: 'Delete Post', action: () => deletePost(comment._id) },
            { text: 'Flag Post', action: () => flagPost() },
          ];
        case isAdmin:
          return [
            { text: 'Flag Post', action: () => flagPost() },
            { text: 'Delete Post', action: () => deletePost(comment._id) },
            {
              text: 'Audit User',
              action: () => auditUser(comment.user),
            },
          ];

        default:
          return [{ text: 'Flag Post', action: () => flagPost() }];
      }
    },
    [isOwner, isAdmin, comment._id, comment.user]
  );

  return (
    <Popup options={getOptions(isOwner, isAdmin)}>
      <BodyText
        sx={{
          fontWeight: 'bold',
          fontSize: 3,
          color: 'grey',
          pointerEvents: 'none',
        }}
      >
        ...
      </BodyText>
    </Popup>
  );
};
